import { useMemo } from "react";
import { useBranding } from "../branding";
import type { AssistantMode } from "../types";

interface Props {
  onPick?: (text: string) => void;
  userName?: string;
  mode: AssistantMode;
}

/** Escolhe até `n` itens variando por dia (sem depender de estado). */
function pick(list: string[], n: number): string[] {
  if (list.length === 0) return [];
  const offset = new Date().getDate() % list.length;
  const rotated = [...list.slice(offset), ...list.slice(0, offset)];
  return rotated.slice(0, n);
}

function firstName(name?: string): string {
  if (!name) return "";
  return name.trim().split(/\s+/)[0] ?? "";
}

export function EmptyState({ onPick, userName, mode }: Props) {
  const { companyName, exampleQuestionsBusiness, exampleQuestionsTechnical, supportExampleQuestions } = useBranding();
  const name = firstName(userName);
  const pool =
    mode === "business"
      ? exampleQuestionsBusiness
      : mode === "support"
        ? supportExampleQuestions
        : exampleQuestionsTechnical;
  const examples = useMemo(() => pick(pool, 4), [pool]);

  const subtitle =
    mode === "business"
      ? `Pergunte sobre regras de negócio, fluxos e jornadas da plataforma ${companyName} - em linguagem simples, sem termos técnicos.`
      : mode === "support"
        ? `Tire dúvidas de suporte N1/N2/N3 sobre ${companyName}: diagnóstico, procedimentos de atendimento e quando escalar.`
        : `Pergunte sobre arquitetura, código, refinamentos ou qualquer coisa do workspace ${companyName}.`;

  return (
    <div className="empty-state">
      <h2 className="empty-greet">{name ? `Olá, ${name}! Como posso ajudar?` : "Como posso ajudar?"}</h2>
      <p className="empty-subtitle">{subtitle}</p>
      <ul className="examples">
        {examples.map((ex) => (
          <li key={ex}>
            <button
              type="button"
              className="example-btn"
              onClick={() => onPick?.(ex)}
              title="Usar esta pergunta"
            >
              {ex}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
